import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import useModalEffect from '../../../hooks/useModalEffect';

const ViewTemplate = ({ isOpen, onClose, data }) => {
  useModalEffect(isOpen);
  ;

  // Cleanup effect when component unmounts
  useEffect(() => {
    return () => {
      // Clean up any remaining modal states when component unmounts
      const cleanupModal = () => {
        // Remove modal scroll lock
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.classList.remove('modal-backdrop');
      };
      
      cleanupModal();
    };
  }, []);


  // Cleanup effect: reset modal body state when component unmounts.
  useEffect(() => {
    return () => {
      // React owns the backdrop DOM (createPortal); only reset body state here.
      // Remove modal-open class from body
      document.body.classList.remove('modal-open');
    };
  }, []);

  if (!data) return null;

  return (
    <>
      <div
        className={`modal modal-blur fade${isOpen ? ' show' : ''}`} style={{ display: isOpen ? 'block' : 'none' }}
        id="modal-view-template"
        tabIndex="-1"
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Template Details</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-6">
                  <p><strong>Template Name:</strong> {data.templateName}</p>
                  <p><strong>Service:</strong> {data.serviceName}</p>
                  <p><strong>Created At:</strong> {new Date(data.createdAt).toLocaleDateString()}</p>
                  <p><strong>Updated At:</strong> {new Date(data.updatedAt).toLocaleDateString()}</p>
                  <p><strong>Status:</strong> {data.isActive ? 'Active' : 'Inactive'}</p>
                </div>
                <div className="col-md-6">
                  <p><strong>Created By:</strong> {data.createdBy}</p>
                  <p><strong>Updated By:</strong> {data.updatedBy}</p>
                </div>
              </div>
              {data.templateContent && (
                <div className="mt-3">
                  <h6>Template Content:</h6>
                  <div className="border p-3 bg-light" 
                       dangerouslySetInnerHTML={{ __html: data.templateContent }}>
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

ViewTemplate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  data: PropTypes.object
};

export default ViewTemplate; 